import * as HLF from "html-living-framework";
import {Callback} from "../core/Reflection";
import {StoryInjection} from "../data/StoryModel";
import {AudioChannel} from "../managers/AudioChannel";
import {StoryCreator} from "../states/StoryCreator";

export class SceneInjectionStopSfx implements StoryInjection {

    private readonly sfx: string[];

    constructor(...sfx: string[]) {
        this.sfx = sfx;
    }

    public execute(storyCreator: StoryCreator, cb: Callback): void {
        AudioChannel.SFX.stop(...this.sfx);
        cb();
    }

    public getAssets(): Array<HLF.IAsset<any>> {
        return [];
    }
}

export class SceneInjectionSfxVolume implements StoryInjection {

    private readonly volume: number;
    private readonly sfx: string[];

    constructor(volume: number, ...sfx: string[]) {
        this.volume = volume;
        this.sfx = sfx;
    }

    public execute(storyCreator: StoryCreator, cb: Callback): void {
        for (const s of this.sfx) {
            const a = AudioChannel.SFX.get(s);
            if (a && a.isPlaying()) {
                a.setVolume(this.volume);
            }
        }
        cb();
    }

    public getAssets(): Array<HLF.IAsset<any>> {
        return [];
    }
}
